if (!customElements.get('featured-collection')) {
    class FeaturedCollection extends HTMLElement {
        constructor() {
            super();
            this.selector = {
                main: this.querySelector('.featured-collection')
            };
            this.state = {
                isDown: false,
                startX: null,
                scrollLeft: null,
                bounceTimeout: null,
                isScrolling: null,
                isDragged: null
            };
            this.load();
        }

        load() {
            if (this.selector.main) {
                this.selector.main.addEventListener('mousedown', event => {
                    this.state.isDown = true;
                    this.selector.main.classList.add('active');
                    this.state.startX = event.pageX - this.selector.main.offsetLeft;
                    this.state.scrollLeft = this.selector.main.scrollLeft;
                });

                this.selector.main.addEventListener('mouseleave', () => {
                    this.state.isDown = false;
                    this.selector.main.classList.remove('active');
                });

                this.selector.main.addEventListener('mouseup', event => {                  
                    this.state.isDown = false;
                    this.selector.main.classList.remove('active');
                });

                this.selector.main.addEventListener('mousemove', event => {
                    if (!this.state.isDown) return;
                    event.preventDefault();
                    const x = event.pageX - this.selector.main.offsetLeft;
                    const walk = (x - this.state.startX) * 2;
                    const newScrollLeft = this.state.scrollLeft - walk;
                    this.selector.main.scrollLeft = newScrollLeft;
                });
            }
        }
    }

    customElements.define('featured-collection', FeaturedCollection);
}